import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { FormElementBaseModel } from '@smarttask-common/src/lib/models/Form/Element/FormElementBaseModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class FormHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.form_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.form_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.form_update, (form_id: string) => {
            this.broadcast(SharedEventNameEnum.form_update, { form_id });
        });

        this.on(SharedEventNameEnum.form_delete, (form_id: string) => {
            this.broadcast(SharedEventNameEnum.form_delete, { form_id });
        });

        this.on(SharedEventNameEnum.form_element_add, (form_id: string, element: FormElementBaseModel) => {
            this.broadcast(SharedEventNameEnum.form_element_add, { form_id, element });
        });

        this.on(SharedEventNameEnum.form_element_update, (form_id: string, element: FormElementBaseModel) => {
            this.broadcast(SharedEventNameEnum.form_element_update, { form_id, element });
        });

        this.on(SharedEventNameEnum.form_element_order_update, (form_id: string, element_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.form_element_order_update, { form_id, element_id, order_index });
        });

        this.on(SharedEventNameEnum.form_element_delete, (form_id: string, element_id: string) => {
            this.broadcast(SharedEventNameEnum.form_element_delete, { form_id, element_id });
        });
    };
}
